module.exports = "pegasus/assets/themelp1/large/20.png";